module.exports = __webpack_public_path__ + "static/img/r_026.2883058.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_026.jpg
// module id = yh2M
// module chunks = 1